export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

const showModal = modal => ({
  type: SHOW_MODAL,
  modal,
});

const hideModal = () => ({ type: HIDE_MODAL });

export default {
  showModal,
  hideModal,
};
